var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRiskOvervie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1719_11354)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1268 21.4301H6.86964L3.30357 25L1.78571 23.4838L3.83929 21.4301H0V0H25V21.4301H21.1589L23.2125 23.4838L21.6964 25L18.1268 21.4301ZM2.14286 2.14301V19.2871H22.8571V2.14301H2.14286ZM6.07143 5.35753H8.21429V16.0726H6.07143V5.35753ZM16.7857 10.7151H18.9286V16.0726H16.7857V10.7151ZM11.4286 8.03629H13.5714V16.0726H11.4286V8.03629Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1719_11354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRiskOvervie);
export default __webpack_public_path__ + "static/media/ic_risk_overvie.2702ee09ed77adfd4dd783223b3f5d02.svg";
export { ForwardRef as ReactComponent };